import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { container } from '../../utils/styles';
import { ContactForm } from './ContactForm';
import { ContactOptions } from './ContactOptions';
import { SectionHeading } from './SectionHeading';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="contact-heading" data-id="element-358" data-mp="3c524maaoio67">
      <div className={`${container} grid gap-12 lg:grid-cols-12 lg:gap-16`} data-id="element-359" data-mp="3g4u8wat1i85r">
        <div className="lg:col-span-5" data-id="element-360" data-mp="3l4fh7bu3nsv5">
          <SectionHeading id="contact-heading" title={t({
          en: 'Ready to Discuss Care Options?',
          es: '¿Listo para Discutir Opciones de Cuidado?'
        })} intro={t({
          en: 'Talk with us about your loved one. The consultation is free, and we’ll answer in English or Spanish.',
          es: 'Conversemos sobre tu ser querido. La consulta es gratuita y te atendemos en inglés o español.'
        })} data-id="element-361" data-mp="3l3dv8cbjplyn" />
          <div className="mt-8" data-id="element-362" data-mp="i31gnyx27cne">
            <ContactOptions data-id="element-363" data-mp="i445806wt305" />
          </div>
        </div>
        <div className="rounded-2xl bg-white p-6 shadow-[0_2px_24px_rgba(44,62,80,0.07)] sm:p-10 lg:col-span-7" data-id="element-364" data-mp="dbb03b7j3snj">
          <h3 className="text-2xl font-bold text-ink" data-id="element-365" data-mp="8bygczbyf1p6">{t({
            en: 'Request a free consultation',
            es: 'Solicita una consulta gratuita'
          })}</h3>
          <p className="mb-7 mt-2 text-ink-soft" data-id="element-366" data-mp="3fgc00kjd5dd">
            {t({
            en: 'Fields marked * are required.',
            es: 'Los campos con * son obligatorios.'
          })}
          </p>
          <ContactForm idPrefix="home-cf" data-id="element-367" data-mp="w3c6qzqjon7i" />
        </div>
      </div>
    </section>;
}